import { useLiveData } from "../hooks/useLiveData";

export default function ChannelLiveBadge({ channelId, liveMap }) {
  // 🔥 bulk varsa onu kullan
  const { liveValue: fallbackValue } = useLiveData(liveMap ? null : channelId);

  const liveValue =
    liveMap && liveMap[channelId] !== undefined
      ? liveMap[channelId]
      : fallbackValue;

  return (
    <div className="channel-live">
      <div className="channel-live-value">
        {liveValue}
      </div>
      <div className="channel-live-label">
        Active TV
      </div>
    </div>
  );
}